import { render } from "./GeHome.vue?vue&type=template&id=ff7a2046"
import script from "./GeHome.vue?vue&type=script&lang=js"
export * from "./GeHome.vue?vue&type=script&lang=js"

import "./GeHome.vue?vue&type=style&index=0&id=ff7a2046&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__